import { api } from '../../app/api/baseApi';

export type ScoreResponse = {
    currentScore?: number;
    maxScore?: number;
    grade?: string | null;
    scoreColor?: string | null;
    scoreName?: string | null;
    scoreSubtitle?: string;
};

export type ScoreQueryParams = Partial<Record<'deviceId' | 'groupId', string | number>> & {
    realmPrefix?: string;
    organizationId?: string;
};

export const scoreApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getScore: builder.query<ScoreResponse, ScoreQueryParams>({
            query: ({ realmPrefix, organizationId, ...params }) => ({
                url: `score/v1/score`,
                params,
                ...(realmPrefix || organizationId
                    ? {
                          headers: {
                              ...(realmPrefix ? { 'x-realm': realmPrefix } : {}),
                              ...(organizationId ? { organizationId } : {}),
                          },
                      }
                    : {}),
            }),
        }),
    }),
    overrideExisting: true,
});

export const { useGetScoreQuery } = scoreApi;
